function showFilters() {
    const filters = document.querySelector("#main-collection-filters");
    const mainContent = document.getElementById("ProductGridContainer");
    const button = document.querySelector(".filter-text");
  
    if (filters.classList.contains("active")) {
        filters.classList.remove("active");
        mainContent.classList.remove("active");
        button.textContent = "Show Filters"; 
    } else {
        filters.classList.add("active");
        mainContent.classList.add("active");
        button.textContent = "Hide Filters";
    }
  }
  
  document.querySelector(".show-filter").addEventListener("click", showFilters);
  showFilters()